import { createFileRoute } from "@tanstack/react-router";
import { guardWorkspaceAccess } from "@/lib/workspaceGuard";
import { OnboardingAuthGate } from "@/components/onboarding/OnboardingAuthGate";
import { OnboardingFirstPost } from "@/components/onboarding/OnboardingFirstPost";
import { useOnboardingStepEvent } from "@/lib/useOnboardingStepEvent";

// Screen 4 (#601, doc-08 §2.2): your first post — write it, or let your
// agent write it.
export const Route = createFileRoute("/onboarding/$workspaceId/first-post")({
  ssr: false,
  beforeLoad: guardWorkspaceAccess,
  component: OnboardingFirstPostRoute,
});

function OnboardingFirstPostRoute() {
  useOnboardingStepEvent("first-post");
  const { workspaceId } = Route.useParams();
  return (
    <OnboardingAuthGate>
      <OnboardingFirstPost workspaceId={workspaceId} />
    </OnboardingAuthGate>
  );
}
